import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import drawerAnimation from '@/Scripts/lib/helper/drawerAnimationHelper';

export default {
  extends: drawerAnimation,
  props: {
    animate: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      opened: false,
      open: false,
      isClosing: false
    };
  },
  methods: {
    toggle: function () {
      if (!this.open) {
        this.runOpen();
      } else {
        this.runClose();
        this.$emit('scrollToMeClose');
      }
    },
    runOpen: function () {
      eventBus.$emit('drawerOpened', { type: this.drawerType, item: this });
      if (this.$mqAliases.desktop && !this.animate) {
        // desktop
        this.$refs.drawer.removeAttribute('style');
        this.open = true;
        this.opened = true;
      } else {
        // mobile
        this.animateOpen();
        this.open = true;
        this.isClosing = false;
        this.$emit('scrollToMeOpen');
      }
    },
    runClose: function () {
      if (!this.isClosing) {
        if (this.$mqAliases.desktop && !this.animate) {
          this.open = false;
          this.opened = false;
        } else {
          this.isClosing = true;
          this.opened = false;
          this.animateClose(() => {
            this.open = false;
            this.isClosing = false;
          });
        }
      }
    },
    closeIfOpen: function () {
      if (this.open) {
        this.runClose();
      }
    },
    _setHeightOnAnimate: function () {
      document.querySelectorAll('.menubar-bottom')[0].style.height = '200%';
    },
    _resetHeightOnAnimate: function () {
      document.querySelectorAll('.menubar-bottom')[0].style.height = '0';
    }
  }
};
